<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu" class="botao-menu-geral">
  <mat-icon class="icon-menu-geral">menu</mat-icon>
</button>
<mat-menu #menu="matMenu">

  <div *ngIf="isUsuarioLogado">
    <button mat-menu-item [matMenuTriggerFor]="atendimentos">
      <mat-icon>support_agent</mat-icon>
      <span>Atendimentos</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="pacientes">
      <mat-icon>local_hospital</mat-icon>
      <span>Pacientes</span>
    </button>
  </div>

  <div *ngIf="isAdminAtdOuAdminOuRoot">
    <button mat-menu-item (click)="manutencaoPlanoSaude()">
      <mat-icon>credit_card</mat-icon>
      <span>Plano Saúde</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="procedimentosManutencao">
      <mat-icon>description</mat-icon>
      <span>Procedimentos</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="medicos">
      <mat-icon>medical_services</mat-icon>
      <span>Medicos</span>
    </button>

    <button mat-menu-item (click)="manutencaoFilial()">
      <mat-icon>business</mat-icon>
      <span>Filiais</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="associacoes">
      <mat-icon>cached</mat-icon>
      <span>Associações</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="relatorios">
      <mat-icon>article</mat-icon>
      <span>Relatórios</span>
    </button>

    <button mat-menu-item [matMenuTriggerFor]="administracao">
      <mat-icon>settings</mat-icon>
      <span>Administração</span>
    </button>
  </div>

  <button mat-menu-item [matMenuTriggerFor]="perfil">
    <mat-icon>face</mat-icon>
    <span>Perfil</span>
  </button>

  <button mat-menu-item (click)="sair()">
    <mat-icon>logout</mat-icon>
    <span>Sair</span>
  </button>
</mat-menu>

<mat-menu #procedimentosManutencao="matMenu">
  <button mat-menu-item (click)="manutencaoProcedimento()">
    <mat-icon>description</mat-icon>
    <span>Procedimentos</span>
  </button>
  <button mat-menu-item (click)="manutencaoProcedimentoAgenda()">
    <mat-icon>date_range</mat-icon>
    <span>Agenda</span>
  </button>
</mat-menu>

<mat-menu #medicos="matMenu">
  <button mat-menu-item (click)="manutencaoMedico()">
    <mat-icon>settings</mat-icon>
    <span>Médicos</span>
  </button>

  <button mat-menu-item (click)="manutencaoEspecialidade()">
    <mat-icon>settings</mat-icon>
    <span>Especialidades</span>
  </button>

  <button mat-menu-item (click)="manutencaoSubEspecialidade()">
    <mat-icon>settings</mat-icon>
    <span>Sub-Especialidades</span>
  </button>

  <button mat-menu-item (click)="manutencaoFaltaMedica()">
    <mat-icon>settings</mat-icon>
    <span>Falta Médica</span>
  </button>

  <button mat-menu-item (click)="manutencaoAgendaMedica()">
    <mat-icon>date_range</mat-icon>
    <span>Agenda Médica</span>
  </button>
</mat-menu>

<mat-menu #perfil="matMenu">
  <button mat-menu-item (click)="redefinirSenha()">
    <mat-icon>password</mat-icon>
    <span>Redefinir Senha</span>
  </button>
</mat-menu>

<mat-menu #associacoes="matMenu">
  <button mat-menu-item (click)="manutencaoAssociacaoFilialMedico()">
    <mat-icon>cached</mat-icon>
    <span>Filial x Médico</span>
  </button>

  <button mat-menu-item (click)="manutencaoAssociacaoFilialEspecialidade()">
    <mat-icon>cached</mat-icon>
    <span>Filial x Especialidade</span>
  </button>

  <button mat-menu-item (click)="manutencaoAssociacaoMedicoPlanoSaude()">
    <mat-icon>cached</mat-icon>
    <span>Médico x Plano Saúde</span>
  </button>

  <button mat-menu-item (click)="manutencaoAssociacaoPlanoSaudeProcedimento()">
    <mat-icon>cached</mat-icon>
    <span>Plano Saúde x Procedimento</span>
  </button>
</mat-menu>

<mat-menu #atendimentos="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="procedimentos">
    <mat-icon>note_add</mat-icon>
    <span>Exames</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="consultas">
    <mat-icon>medical_services</mat-icon>
    <span>Consultas</span>
  </button>
</mat-menu>

<mat-menu #consultas="matMenu">
  <button mat-menu-item (click)="manutencaoAtendimentoConsulta()">
    <mat-icon>sick</mat-icon>
    <span>Atender Paciente</span>
  </button>
  <button mat-menu-item (click)="localizarAtendimentoConsulta()">
    <mat-icon>search</mat-icon>
    <span>Localizar Consulta</span>
  </button>
</mat-menu>

<mat-menu #procedimentos="matMenu">
  <button mat-menu-item (click)="manutencaoAtendimentoProcedimento()">
    <mat-icon>sick</mat-icon>
    <span>Atender Paciente</span>
  </button>
  <button mat-menu-item (click)="localizarAtendimentoProcedimento()">
    <mat-icon>search</mat-icon>
    <span>Localizar Exame</span>
  </button>
</mat-menu>

<mat-menu #pacientes="matMenu">
  <button mat-menu-item (click)="manutencaoPaciente()">
    <mat-icon>person</mat-icon>
    <span>Pacientes</span>
  </button>

  <button mat-menu-item (click)="manutencaoDependente()">
    <mat-icon>child_care</mat-icon>
    <span>Dependentes</span>
  </button>
</mat-menu>

<mat-menu #relatorios="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="relatorioConsulta">
    <mat-icon>article</mat-icon>
    <span>Rel. Consultas</span>
  </button>

  <button mat-menu-item [matMenuTriggerFor]="relatorioExame">
    <mat-icon>article</mat-icon>
    <span>Rel. Exames</span>
  </button>

  <button mat-menu-item [matMenuTriggerFor]="relatorioGlobal">
    <mat-icon>article</mat-icon>
    <span>Rel. Global</span>
  </button>
</mat-menu>

<mat-menu #relatorioConsulta="matMenu">
  <button mat-menu-item (click)="relDisponibilidadeDeVagasParaConsulta()">
    <mat-icon>article</mat-icon>
    <span>Vagas Disponíveis</span>
  </button>
  <button mat-menu-item (click)="relMarcacoesInternasParaConsulta()">
    <mat-icon>article</mat-icon>
    <span>Marcações Internas</span>
  </button>
  <button mat-menu-item (click)="relMarcacoesConsultas()">
    <mat-icon>article</mat-icon>
    <span>Marcações Consultas</span>
  </button>
</mat-menu>

<mat-menu #relatorioExame="matMenu">
  <button mat-menu-item (click)="relDisponibilidadeDeVagasParaExame()">
    <mat-icon>article</mat-icon>
    <span>Vagas Disponíveis</span>
  </button>
  <button mat-menu-item (click)="relMarcacoesInternasParaExame()">
    <mat-icon>article</mat-icon>
    <span>Marcações Internas</span>
  </button>
  <button mat-menu-item (click)="relMarcacoesExames()">
    <mat-icon>article</mat-icon>
    <span>Marcações Exames</span>
  </button>
</mat-menu>

<mat-menu #relatorioGlobal="matMenu">
  <button mat-menu-item (click)="relMarcacoesInternasGlobal()">
    <mat-icon>article</mat-icon>
    <span>Marcações Internas</span>
  </button>
</mat-menu>

<mat-menu #administracao="matMenu">
  <button mat-menu-item (click)="manutencaoFeriados()">
    <mat-icon>card_travel</mat-icon>
    <span>Feriados</span>
  </button>

  <button mat-menu-item (click)="manutencaoMotivoCancelamento()">
    <mat-icon>cancel_presentation</mat-icon>
    <span>Motivo Cancelamento</span>
  </button>

  <div *ngIf="isAdminOuRoot">
    <button mat-menu-item (click)="historicoEventosSistema()">
      <mat-icon>history</mat-icon>
      <span>Hist. Eventos Sistema</span>
    </button>
  </div>

  <button mat-menu-item (click)="manutencaoUsuario()">
    <mat-icon>person</mat-icon>
    <span>Usuários</span>
  </button>

  <button mat-menu-item [matMenuTriggerFor]="notificacoes">
    <mat-icon>notifications</mat-icon>
    <span>Notificações</span>
  </button>
</mat-menu>

<mat-menu #notificacoes="matMenu">
  <button mat-menu-item (click)="notificacoesCancelamento()">
    <mat-icon>notifications_off</mat-icon>
    <span>Notific. Cancelamento</span>
  </button>
  
  <button mat-menu-item (click)="envioComprovante()">
    <mat-icon>forward_to_inbox</mat-icon>
    <span>Hist. Envio Comprovante</span>
  </button>

  <button mat-menu-item (click)="reenvioComprovanteExame()">
    <mat-icon>send</mat-icon>
    <span>Reenvio Comprovante (Exame)</span>
  </button>
 
  <button mat-menu-item (click)="reenvioComprovanteConsulta()">
    <mat-icon>send</mat-icon>
    <span>Reenvio Comprovante (Consulta)</span>
  </button>
</mat-menu>